import { EventTimeEntriesQueryVariables } from '@/__generated__/graphql';
import { EVENT_TIME_QUERY } from '@/gql/queries/eventIndexQueries.gql';
import { useQuery } from '@apollo/client';
import { parseEventTimeFragment } from '../parsers/common/parseEventTime';

export const useEventTimeEntries = (variables: EventTimeEntriesQueryVariables) => {
  const { data, loading, error } = useQuery(EVENT_TIME_QUERY, {
    variables,
  });

  const timeFieldEntries = data?.eventTimeFieldEntries;

  const result = parseEventTimeFragment(timeFieldEntries);

  return {
    result,
    loading,
    error,
  };
};
